module.exports = __webpack_public_path__ + "media/site/images/claim-white-c72f2cce3018611efd750dbd47c0cbba.png";